import { useState, useContext } from "react";
import { assets } from "../../assets/assets";

import { resetPasswordRoute, checkResetTokenRoute, changeTwoFactor, changeUserTypeRoute, changeUserAuthorisationRoute, changeUserInviteAccessRoute } from "../../api/routes";
import PopUpPanel from "../../components/PopUpPanel/PopUpPanel";
import ProfilePic from "../../components/ProfilePic/ProfilePic";
import DropDownList from "../../components/forms/DropDownList/DropDownList";
import { getAcTypeData, getAcTypeDisplayName, getAcDropListData } from "../../helpers/AccountTypes";
import { getShortDateString, getShortDateTimeString } from "../../helpers/Dates";
import { ProfilePicURL } from "../../helpers/ProfilePicURL";
import Toggle from "../../components/forms/Toggle/Toggle";
import { IconJsxer } from "../../helpers/IconHelper";
import "./EditUser.scss";
import { AuthContext } from "../../contexts/AuthContext";

import { toast } from "react-toastify";
import axios from "../../api/axios";

const EditUser = (props) => {
    const [authContext, setAuthContext] = useContext(AuthContext);
    const { user, maxChangeLevel, closePanelFunc } = props;
    const [isEditing, setIsEditing] = useState(false);
    const acTypeData = getAcTypeData(user.acType);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editSelectedType, setEditSelectedType] = useState(user.acType || 'not_set');
    const [editAuthorised, setEditAuthorised] = useState(!!user.isAuthorised);
    const [editInviteAccess, setEditInviteAccess] = useState(!!user.canInviteUsers);
    const [editSubmitting, setEditSubmitting] = useState(false);
    
    // Always include the current user's type in the dropdown, even if above permission level
    const baseOptions = getAcDropListData([], maxChangeLevel || 100, [], true);
    const currentTypeData = getAcTypeData(user.acType);
    const currentTypeOption = {
        id: user.acType || 'not_set', 
        label: currentTypeData ? currentTypeData.shortName : 'Current Type',
        colorCss: currentTypeData?.colorCss,
        profilePicBorderCss: currentTypeData?.profilePicBorderCss,
    };
    
    // Check if current type is already in the list
    const hasCurrentType = baseOptions.some(opt => opt.id === currentTypeOption.id);
    const finalOptions = hasCurrentType ? baseOptions : [currentTypeOption, ...baseOptions];
    
    // Check if user can be changed - user's current level must be <= maxChangeLevel
    const currentUserLevel = currentTypeData ? currentTypeData.level : 0;
    const canChangeUserType = (maxChangeLevel || 0) >= currentUserLevel;
    
    const [acOptions] = useState(finalOptions);
    const selectedTypeIndex = Math.max(acOptions.findIndex(opt => opt.id === editSelectedType), 0);
    const campaignCount = typeof user.campaigns === 'number' ? user.campaigns : (Array.isArray(user.campaigns) ? user.campaigns.length : (user.campaigns ? user.campaigns.length : 0));

    console.log('EditUser opened - user.acType:', user.acType);
    console.log('EditUser opened - editSelectedType:', editSelectedType);
    console.log('EditUser opened - maxChangeLevel:', maxChangeLevel);
    console.log('EditUser opened - currentUserLevel:', currentUserLevel);
    console.log('EditUser opened - canChangeUserType:', canChangeUserType);
    console.log('EditUser opened - acOptions:', acOptions);
    console.log('Available user type levels for maxChangeLevel', maxChangeLevel, ':', 
        acOptions.map(opt => {
            const typeData = getAcTypeData(opt.id);
            return `${opt.label} (${opt.id}) - level ${typeData?.level || 'unknown'}`;
        }));

    const resetPasswordFormSubmitHandler = (e) => {
        e.preventDefault();
        if(!isSubmitting) {
            setIsSubmitting(true);
            axios
                .post(resetPasswordRoute, {
                    email: user.email,
                    resetToken: props.resetToken,
                    password: 'FORCERESET',
                    confirmPassword: 'FORCERESET'
                })
                .then(function (response) {
                    setIsSubmitting(false);
                    navigator.clipboard.writeText(response.data.newPassword);
                    toast.success('User\'s password reset! Copied to clipboard');
                })
                .catch(function (error) {
                    console.log("frontend reset password catch")
                    console.table(error)
                    setIsSubmitting(false);
                    toast.error('Error - ' + error.response.data.message);
                });
        }
    };

    const setUserTwoFactor = () => {
    setIsSubmitting(true);
        user.ignoreTwoFactor = !user.ignoreTwoFactor;
        axios.post(changeTwoFactor, {userID:user._id, ignoreTwoFactor:user.ignoreTwoFactor, withCredentials:true})
            .then(function (response) {
                setIsSubmitting(false);
                const data = response.data
                toast.success("Two factor successfully changed!");
            })
            .catch(function (error) {
                setIsSubmitting(false);
                toast.error('Error - ' + error.response.data.message);
            });
    }

    const updateSelectedType = (e, dropDownId, item) => {
        setEditSelectedType(item.id);
    }

    const saveEditChanges = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (editSubmitting) return;
        setEditSubmitting(true);
        
        console.log('Save changes - Current user:', user);
        console.log('Save changes - editSelectedType:', editSelectedType);
        console.log('Save changes - editAuthorised:', editAuthorised);
        console.log('Save changes - editInviteAccess:', editInviteAccess);
        console.log('Route check - changeUserTypeRoute:', changeUserTypeRoute);
        console.log('Route check - changeUserAuthorisationRoute:', changeUserAuthorisationRoute);
        console.log('Route check - changeUserInviteAccessRoute:', changeUserInviteAccessRoute);
        
        try {
            let userUpdated = false;
            
            if (editSelectedType && editSelectedType !== user.acType && canChangeUserType) {
                const typePayload = { id: user._id, newType: editSelectedType };
                console.log('Sending user type change:', typePayload);
                console.log('axios.post params:', changeUserTypeRoute, typePayload, { withCredentials: true });
                const response = await axios.post(changeUserTypeRoute, typePayload, { withCredentials: true });
                console.log('User type change response:', response);
                // Update the local user object
                user.acType = editSelectedType;
                userUpdated = true;
            } else if (editSelectedType !== user.acType && !canChangeUserType) {
                console.log('Skipping user type change - insufficient permissions');
            }
            if (editAuthorised !== !!user.isAuthorised) {
                const authPayload = { id: user._id };
                console.log('Sending user auth change:', authPayload);
                await axios.post(changeUserAuthorisationRoute, authPayload, { withCredentials: true });
                // Update the local user object
                user.isAuthorised = editAuthorised;
                userUpdated = true;
            }
            if (editInviteAccess !== !!user.canInviteUsers) {
                const invitePayload = { id: user._id, canInvite: editInviteAccess };
                console.log('Sending invite access change:', invitePayload);
                await axios.post(changeUserInviteAccessRoute, invitePayload, { withCredentials: true });
                // Update the local user object
                user.canInviteUsers = editInviteAccess;
                userUpdated = true;
            }
            
            if (userUpdated) {
                toast.success('User updated');
                
                // Close the edit popup and refresh the list
                if (props.onUserUpdated) {
                    console.log('Calling onUserUpdated callback...');
                    props.onUserUpdated();
                }
                
                // Close the popup after a short delay to allow the refresh
                setTimeout(() => {
                    closePanelFunc();
                }, 200);
            } else {
                //toast.info('No changes to save');
                setIsEditing(false);
            }
        } catch (err) {
            console.error('Save error:', err);
            console.error('Error response:', err.response);
            console.error('Error response data:', err.response?.data);
            console.error('Error message:', err.response?.data?.msg || err.message);
            toast.error('Error updating user: ' + (err.response?.data?.msg || err.message));
        } finally {
            setEditSubmitting(false);
        }
    }

    if (isEditing) {
        // Check if current selected type allows invitation access
        const canInviteUsers = editSelectedType === 'koko_super_user' || editSelectedType === 'twitch_super_user';
        const inviteAccessValue = canInviteUsers ? editInviteAccess : false;
        const inviteAccessText = inviteAccessValue ? 'able to invite new users' : "can't invite new users";
        
        // Edit form view matching wireframe exactly
        return (
            <PopUpPanel closePanelFunc={closePanelFunc}>
                <div className="edit-user-container">
                    <div className="edit-header">
                        <button className="back-btn" onClick={() => setIsEditing(false)}>
                            {IconJsxer.GetIcon(IconJsxer.ICONS.chevronLeft, IconJsxer.ICON_STYLES.standard)}
                        </button>
                        <span className="user-name">{user.firstName} {user.lastName}</span>
                    </div>
                    
                    <h2 className="edit-title">Edit profile</h2>

                    <form onSubmit={saveEditChanges} className="edit-form">
                        <div className="form-field">
                            <label className="field-label">User type</label>
                            <DropDownList
                                id="edit-user-type"
                                className="field-dropdown"
                                items={acOptions}
                                currentIndex={selectedTypeIndex}
                                selectFunc={updateSelectedType}
                                disabled={!canChangeUserType}
                                enabled={canChangeUserType}
                                showErrors={false}
                            />
                            {!canChangeUserType && (
                                <div className="permission-notice">
                                    <small>User type cannot be changed - insufficient permissions</small>
                                </div>
                            )}
                        </div>

                        <div className="form-field">
                            <label className="field-label">Invitation access</label>
                            <div className="toggle-row">
                                <Toggle 
                                    currentState={inviteAccessValue} 
                                    toggleFunc={() => canInviteUsers && setEditInviteAccess(!editInviteAccess)} 
                                    enabled={canInviteUsers} 
                                />
                                <span className="toggle-label">{inviteAccessText}</span>
                                <button type="button" className="info-icon" title="Info">
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.moreInfo, IconJsxer.ICON_STYLES.standard)}
                                    <div className="info-tooltip">
                                        Invitation access is available to 'Twitch Super' and 'Koko Digital' user types only
                                    </div>
                                </button>
                            </div>
                        </div>

                        <div className="form-field">
                            <label className="field-label">User access</label>
                            <div className="toggle-row">
                                <Toggle 
                                    currentState={editAuthorised} 
                                    toggleFunc={() => setEditAuthorised(!editAuthorised)} 
                                    enabled={true} 
                                />
                                <span className="toggle-label">authorise access to ICAST</span>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button type="submit" className="confirm-btn" disabled={editSubmitting}>
                                Confirm changes
                            </button>
                        </div>
                    </form>
                </div>
            </PopUpPanel>
        );
    }
    
    return (
        <PopUpPanel closePanelFunc={closePanelFunc}>
            <div className="user-view-container">
                <div className="user-header">
                    <div className="user-profile-row">
                        <div className="user-profile-pic">
                            <ProfilePic size="large" className="pp-style" user={user} />
                            {user.isTwitchLogin && 
                                <div className="icon-overlay">
                                    <img src={assets.TwitchPPicIcon} alt="" className="tw-ppic-icon" />
                                </div>
                            }
                        </div>
                        <div className="user-name-email">
                            <div className="user-name-section">
                                <h2>{user.firstName} {user.lastName}</h2>
                                <button 
                                    className="edit-icon-btn" 
                                    onClick={() => setIsEditing(true)}
                                    title="Edit user details"
                                >
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.editOutline, IconJsxer.ICON_STYLES.standard)}
                                </button>
                            </div>
                            <p className="user-email">{user.email}</p>
                        </div>
                    </div>
                    
                    <div className="user-stats">
                        <div className="stat-item">
                            <span className="stat-label">Member since</span>
                            <span className="stat-value">{getShortDateString(user.dateCreated)}</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-label">Last active</span>
                            <span className="stat-value">{getShortDateTimeString(user.lastActive)}</span>
                        </div>
                    </div>
                </div>

                <div className="user-details-list">
                    <div className="detail-item">
                        <div className="detail-label">User type</div>
                        <div className="detail-value">{getAcTypeDisplayName(user.acType)}</div>
                    </div>

                    <div className="detail-item">
                        <div className="detail-label">User access</div>
                        <div className="detail-value">Can access ICAST</div>
                    </div>

                    {user.isTwitchLogin && (
                        <div className="detail-item">
                            <div className="detail-label">Twitch handle</div>
                            <div className="detail-value">{user.name}</div>
                        </div>
                    )}

                    <div className="detail-item">
                        <div className="detail-label">Account ID</div>
                        <div className="detail-value">{user._id}</div>
                    </div>

                    <div className="detail-item">
                        <div className="campaigns-header">
                            <span className="detail-label">Total campaigns</span>
                            <div className="campaign-count-circle">
                                {campaignCount}
                            </div>
                        </div>
                        <button className="view-all-btn">View all</button>
                    </div>
                </div>
            </div>
        </PopUpPanel>
    );
}

export default EditUser;
